const NoData = () => {
  return (
    <div className="text-center mtx-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        class="no-data-icon"
      >
        <path d="m2 2 20 20" />
        <path d="M8.35 2.69A10 10 0 0 1 21.3 15.65" />
        <path d="M19.08 19.08A10 10 0 1 1 4.92 4.92" />
      </svg>
      <h2 className="no-data-title">No Data</h2>
    </div>
  );
};

export default NoData;
